export interface SupplierDeliverySchedule {
  weekday: number;
  cutoff_days_before: number;
  cutoff_time: string;
}

export const WEEKDAY_OPTIONS = [
  { value: 0, label: "Montag" },
  { value: 1, label: "Dienstag" },
  { value: 2, label: "Mittwoch" },
  { value: 3, label: "Donnerstag" },
  { value: 4, label: "Freitag" },
  { value: 5, label: "Samstag" },
  { value: 6, label: "Sonntag" },
] as const;

export function emptyDeliverySchedule(): SupplierDeliverySchedule {
  return {
    weekday: 1,
    cutoff_days_before: 1,
    cutoff_time: "16:00",
  };
}

export function formatCutoffDescription(
  cutoffDaysBefore: number,
  cutoffTime: string,
): string {
  const time = cutoffTime.slice(0, 5);
  if (cutoffDaysBefore === 0) return `am Liefertag bis ${time} Uhr`;
  if (cutoffDaysBefore === 1) return `Vortag bis ${time} Uhr`;
  return `${cutoffDaysBefore} Tage vorher bis ${time} Uhr`;
}
